// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"e964d53c","787":"65a59f4b"}[chunkId] + ".chunk.js";
};